import { Form } from '@procore/core-react'
import React from 'react'

interface SingleFormProps {
  component?: any
  debug?: boolean
  initialValue?: any
  variant?: React.ComponentProps<typeof Form>['variant']
  view?: React.ComponentProps<typeof Form>['view']
  // TODO: textEditorComponent: any
}

/**
 * Takes a Form Field component with TextEditor and creates
 * a full Form of one view and variant.
 */
const SingleForm = ({
  component: FieldComponent = Form.Field,
  debug,
  initialValue,
  view,
  variant,
  // TODO: textEditorComponent,
  ...props
}: SingleFormProps) => {
  // removes colStart from DOM for traditional variant
  const columnOne = variant === 'traditional' ? {} : { colStart: 1 }
  const columnTwo = variant === 'traditional' ? {} : { colStart: 7 }

  return (
    <Form
      enableReinitialize
      initialValues={{
        value: initialValue,
      }}
      variant={variant}
      view={view}
      onSubmit={(values) => alert(JSON.stringify(values, null, 2))}
    >
      <Form.Form>
        <Form.Row>
          <FieldComponent
            name="empty"
            label="Empty Text"
            description="Empty Description"
            // TODO: textEditorComponent={textEditorComponent}
            {...columnOne}
            {...props}
          />
          <FieldComponent
            name="value"
            label="Initial Value Text"
            description="Initial Value Description"
            // TODO: textEditorComponent={textEditorComponent}
            {...columnTwo}
            {...props}
          />
        </Form.Row>
        <Form.Row>
          <FieldComponent
            name="disabled-empty"
            disabled
            label="Disabled Empty Text"
            description="Disabled Empty Description"
            // TODO: textEditorComponent={textEditorComponent}
            {...columnOne}
            {...props}
          />
          <FieldComponent
            name="disabled-value"
            disabled
            label="Disabled Initial Value Text"
            description="Disabled Initial Description"
            // TODO: textEditorComponent={textEditorComponent}
            {...columnTwo}
            {...props}
          />
        </Form.Row>
        <Form.Row>
          <FieldComponent
            name="error-empty"
            error
            label="Error Boolean Empty Text"
            description="Error Boolean Description"
            // TODO: textEditorComponent={textEditorComponent}
            {...columnOne}
            {...props}
          />
          <FieldComponent
            name="error-value"
            error="Some error message that should be read red"
            label="Error Message Initial Value Text"
            description="Error Message Initial Description"
            // TODO: textEditorComponent={textEditorComponent}
            {...columnTwo}
            {...props}
          />
        </Form.Row>
      </Form.Form>
    </Form>
  )
}

/** All variations for a field with TextEditor.
 * @example
 *  <BaseCRU
      component={Form.RichText}
      initialValue="<p>Hello</p>"
      textEditorComponent={TextEditor}
    />
 */
export function BaseCRU<Element extends React.JSXElementConstructor<any>>(
  props: Omit<SingleFormProps, 'component'> & {
    component: Element
    // TODO: textEditorComponent: any
  } & Omit<React.ComponentProps<Element>, 'name'>
) {
  return <SingleForm view="create" {...props} />
}
